module.exports = __webpack_public_path__ + "static/media/pedra-deck-adroit.2063e380.png";